import { SaveFeedbackContextValue } from '@modules/feedback/components/FeedbackCard/SaveFeedbackContext';

interface IsSavedSnippetIDMatchingParams {
  savedSnippetID: string;
  feedbackID: string;
  savedFeedbackContext: SaveFeedbackContextValue | null;
}

export const isSavedSnippetIDMatching = ({
  savedSnippetID,
  feedbackID,
  savedFeedbackContext,
}: IsSavedSnippetIDMatchingParams) => {
  if (!savedFeedbackContext?.snippetID) {
    return false;
  }

  return (
    savedSnippetID.includes(feedbackID) &&
    savedSnippetID.includes(`[labelID=${savedFeedbackContext.labelID}]`) &&
    savedSnippetID.includes(
      `[summaryHash=${savedFeedbackContext.summaryHash}]`,
    ) &&
    savedSnippetID.includes(`[summaryIdx=${savedFeedbackContext.summaryIndex}]`)
  );
};
